import { IDocumentsActive } from "store/lobby/lobby-model";

export interface IReport {
  id: number;
  structure: string;
  location: string;
  locationCode?: string;
  vehiclePlate: string;
  inboundTrailersPlates?: string[];
  carrier: string;
  process: string;
  inboundInvoices: string;
  documents: IDocumentsActive;
  checkinEventTime?: string;
  inboundObservation?: string;
  inboundEventTime: string;
  outboundEventTime?: string;
  outboundTrailersPlates?: string;
  outboundObservation?: string;
  outboundInvoices?: string;
}

export interface IReportFilter {
  itemsByPage: number;
  pageIndex: number;
  structureId: number;
  location?: string;
  initialEventTime: string;
  finalEventTime: string;
  plate?: string;
  document?: string;
  trailerPlate?: string;
}

export interface IReportMovementFilter {
  itemsByPage: number;
  pageIndex: number;
  structureId: number;
  location?: string;
  initialEventTime: string;
  finalEventTime: string;
  plate?: string;
  dtDocument?: string;
  trailerPlate?: string;
}

export type IDriver = {
  name: string;
  cpf: string;
};

export type IDocument = {
  type: string;
  value: string;
};

export type IItems = {
  id: number;
  carrier: string;
  checkinEventTime: string;
  drivers?: Array<IDriver>;
  inboundDocuments: Array<IDocument>;
  inboundEventTime: string;
  inboundObservation: string;
  inboundProcessDescription: string;
  inboundTrailersPlates: string;
  location: string;
  locationCode: string;
  outboundDocuments: Array<IDocument>;
  outboundEventTime: string;
  outboundObservation: string;
  outboundProcessDescription: string;
  outboundTrailersPlates: string;
  structure: string;
  vehiclePlate: string;
  trailerType?: number;
  fleetChannelId?: number;
};

export type IMovementItems = {
  id: number;
  structure: string;
  location: string;
  vehiclePlate: string;
  inboundTrailersPlates: string;
  outboundTrailersPlates: string;
  dtDocument: string;
  vehicleCheckinEventTime: string;
  checkinSource: string;
  radiusInEventTime: string;
  vehicleReleasedEventTime: string;
  requestVehicleForGateEventTime: string;
  inboundEventTime: string;
  requestDockEntryEventTime: string;
  finishedOperationEventTime: string;
  outboundEventTime: string;
  rangeOutboundEventTime: string;
  canceledAt: string;
};

export interface IReportState {
  isLoading: boolean;
  isLoadingMovements: boolean;
  isLoadingRegisters: boolean;
  isLoadingMovementsRegisters: boolean;
  filter: IReportFilter;
  movementFilter: IReportMovementFilter;
  items?: IItems[];
  movementItems?: IMovementItems[];
  totalItems: number;
  movementTotalItems: number;
  itemActive: IReport;
  inboundDocumentsTypes: string[];
  outboundDocumentsTypes: string[];
}

export const defaultState: IReportState = {
  isLoading: false,
  isLoadingRegisters: false,
  isLoadingMovements: false,
  isLoadingMovementsRegisters: false,
  movementItems: [],
  items: [],
  itemActive: null,
  totalItems: 0,
  movementTotalItems: 0,
  inboundDocumentsTypes: [],
  outboundDocumentsTypes: [],
  filter: {
    itemsByPage: 10,
    pageIndex: 1,
    structureId: null,
    location: null,
    initialEventTime: null,
    finalEventTime: null,
    plate: null,
    document: null,
    trailerPlate: null,
  },
  movementFilter: {
    itemsByPage: 10,
    pageIndex: 1,
    structureId: null,
    location: null,
    initialEventTime: null,
    finalEventTime: null,
    plate: null,
    dtDocument: null,
    trailerPlate: null,
  },
};
